import React, { Suspense, useEffect } from 'react';
import { createStorageHandler } from 'utils/session.utils';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import store from 'store/store';
import { Provider } from 'react-redux';
import SignUp from 'screens/sign_up/sign_up.screen';
import LogIn from 'screens/log_in/log_in.screen';
import ForgotPassword from 'screens/forgot_password/forgot_password.screen';
import EnterOtpScreen from 'screens/enter_otp/enter_otp.screen';
import ResetPassword from 'screens/reset_password/reset_password.screen';
import ResetPasswordSuccessful from 'screens/reset_password_successful/reset_password_successful.screen';
import AccountSettings from 'screens/account_settings/account_settings.screen';
import Welcome from "screens/welcome/welcome.screen";
import Editor from 'screens/editor/editor.screen';
import Preview from 'screens/preview/preview.screen';
import AR from 'screens/ar/ar.screen';
import { Toaster } from 'react-hot-toast';
import AdminOverview from 'screens/admin_overview/admin_overview.screen';
import AdminUsers from 'screens/admin_users/admin_users.screen';
import AdminUserDetail from 'screens/admin_user_detail/admin_user_detail.screen';
import AdminProjects from 'screens/admin_projects/admin_projects.screen';
import AdminProjectDetail from 'screens/admin_project_detail/admin_project_detail.screen';
import AdminTickets from 'screens/admin_tickets/admin_tickets.screen';
import AdminTicketDetail from 'screens/admin_ticket_detail/admin_ticket_detail.screen';
import Support from 'screens/support/support.screen';
import PlanScreen from 'screens/plan_management/plan_management.screen';
import './App.scss';

function App() {
  // Another tab signing in as a different account, or logging out, must not leave this tab
  // showing one identity while its requests (shared localStorage token) go out as another.
  useEffect(() => {
    const onStorage = createStorageHandler();
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<div />}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />}></Route>
            <Route path="/signup" element={<SignUp/>}></Route>
            <Route path="/login" element={<LogIn/>}></Route>
            <Route path="/forgot-password" element={<ForgotPassword/>}></Route>
            <Route path="/enter-otp" element={<EnterOtpScreen/>}></Route>
            <Route path="/reset-password" element={<ResetPassword/>}></Route>
            <Route path="/reset-password-successful" element={<ResetPasswordSuccessful/>}></Route>
            <Route path="/account-settings" element={<AccountSettings/>}></Route>
            <Route path="/welcome" element={<Welcome/>}></Route>
            <Route path="/editor" element={<Editor/>}></Route>
            <Route path="/preview/:projectId" element={<Preview/>}></Route>
            <Route path="/ar" element={<AR/>}></Route>
            <Route path="/admin" element={<AdminOverview/>}></Route>
            <Route path="/admin/overview" element={<AdminOverview/>}></Route>
            <Route path="/admin/users" element={<AdminUsers/>}></Route>
            <Route path="/admin/users/:userId" element={<AdminUserDetail/>}></Route>
            <Route path="/admin/projects" element={<AdminProjects/>}></Route>
            <Route path="/admin/projects/:projectId" element={<AdminProjectDetail/>}></Route>
            <Route path="/admin/tickets" element={<AdminTickets/>}></Route>
            <Route path="/admin/tickets/:ticketId" element={<AdminTicketDetail/>}></Route>
            <Route path="/support" element={<Support/>}></Route>
            <Route path="/upgrade-plan" element={<PlanScreen/>}></Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster 
      />
    </Provider>
  );
}

export default App;
